type Options = {
  type: string;
  side: string;
};

type Log = {
  time: Date;
  method: string;
  url: string;
  params: string | {};
  fromCache?: boolean;
};

type Logs = Array<Log>;

enum Type {
  REQUEST = 'request',
  RESPONSE = 'response',
}

enum Side {
  SSR = 'SSR',
  CSR = 'CSR',
}

const REQUEST_TABLE_TEMPLATE = ['time', 'method', 'url', 'params'];
const RESPONSE_TABLE_TEMPLATE = [
  'time',
  'method',
  'url',
  'params',
  'fromCache',
];

export default class AxiosResReqLogger {
  private logs: Logs = [];
  private type: string;
  private side: string;
  private isNodeVersionMoreThenTen: boolean = true;

  constructor(option: Options) {
    this.type = option.type || Type.REQUEST;
    this.side = option.side || Side.SSR;
    this.nodeVersionChecker(process.version);
  }

  private addResponseLog(type: any) {
    this.logs.push({
      time: new Date(),
      method: type.config.method,
      url: `${type.config.baseURL}${type.config.url}`,
      params: type.config.params || 'no params',
      fromCache: type.request.fromCache || false,
    });
  }

  private addRequestLog(type: any) {
    this.logs.push({
      time: new Date(),
      method: type.method,
      url: `${type.baseURL}${type.url}`,
      params: type.params || 'no params',
    });
  }

  private consoleResponseLogs(type: string) {
    if (this.logs.length) {
      console.log(`${type} Axios response`);
      this.isNodeVersionMoreThenTen
        ? console.table(this.logs, RESPONSE_TABLE_TEMPLATE)
        : this.consoleStringLogs(this.logs);
    }
  }

  private consoleRequestLogs(type: string) {
    if (this.logs.length) {
      console.log(`${type} Axios request`);
      this.isNodeVersionMoreThenTen
        ? console.table(this.logs, REQUEST_TABLE_TEMPLATE)
        : this.consoleStringLogs(this.logs);
    }
  }

  private consoleStringLogs(logs: Logs) {
    logs.forEach(({ time, method, url, params, fromCache }) => {
      const stringLog = `time: ${time}, method: ${method}, url: ${url}, params: ${JSON.stringify(
        params,
      )}`;

      console.log(
        fromCache !== undefined
          ? `${stringLog}, fromCache: ${fromCache}`
          : stringLog,
      );
    });
  }

  private clearLoggs() {
    this.logs.length = 0;
  }

  private nodeVersionChecker(nodeVersion: string) {
    if (!nodeVersion) return;
    if (/v([6-9]|10)/.test(nodeVersion)) this.isNodeVersionMoreThenTen = false;
  }

  writeLogs(axiosType: any) {
    if (this.type === Type.RESPONSE) {
      this.addResponseLog(axiosType);
    }
    if (this.type === Type.REQUEST) {
      this.addRequestLog(axiosType);
    }
  }

  showLogs() {
    if (this.type === Type.RESPONSE) {
      this.consoleResponseLogs(this.side);
    }
    if (this.type === Type.REQUEST) {
      this.consoleRequestLogs(this.side);
    }
    this.clearLoggs();
  }
}

const responseSSRLogger = new AxiosResReqLogger({
  type: 'response',
  side: 'SSR',
});

const requestSSRLogger = new AxiosResReqLogger({
  type: 'request',
  side: 'SSR',
});

export { responseSSRLogger, requestSSRLogger };



// WEBPACK FOOTER //
// ./src/tools/axioslogger/index.ts